import { useQuery } from '@tanstack/react-query'
import { STOCK } from '../../constants/endpoints'
import { getStock } from '../../utils/getStock'
import { useAuthStore } from '@/features/auth/store/authStore'

export const useInventoryStockQuery = ({ enabled }: { enabled: boolean }) => {
  const userId = useAuthStore((state) => state.user?._id)

  return useQuery({
    queryKey: [STOCK, userId],
    queryFn: getStock,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
